import { useEffect, useState } from "react";
import { waitMessageKey } from "./loader-copy";
import type { MessageKey } from "../i18n/en";

/** Time-escalating wait copy: returns the message key for how long `active` has
 * been true. Resets when the wait ends. Used by slow fetches that have no real
 * progress signal — the message gets more informative the longer it drags. */
export function useWaitMessage(active: boolean): MessageKey {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!active) {
      setElapsed(0);
      return;
    }
    const start = Date.now();
    const id = setInterval(() => setElapsed(Date.now() - start), 1000);
    return () => clearInterval(id);
  }, [active]);
  return waitMessageKey(elapsed);
}
